import styled from 'styled-components';
import VdpBox from '../../../_shared/components/VdpBox';
import Button from '../../../_shared/components/Button';

export const RetailVdpBox = styled(VdpBox)`
  display: flex;
  flex-direction: column;
`;

export const RetailVdpHeading = styled.h2`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const RetailVdpMessage = styled.p``;

export const RetailVdpButton = styled(Button.Secondary)``;
